import {ContextInfoProps} from '@deviceinsight/ng-ui-scale-lib/api';

export default (contextInfo: ContextInfoProps['contextInfo'] | null | undefined) => {
	if (contextInfo && contextInfo.type === 'assetGroup') {
		const {
			assetGroupDefinition: {name}
		} = contextInfo;
		return name !== 'Inventory';
	}

	return true;
};
